import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil, tap, timer } from 'rxjs';
import { DataListComponent } from '../../../shared/ui/data-list/data-list.component';
import { DataListItemDirective } from '../../../shared/ui/data-list/data-list-item.directive';
import { BrIconComponent } from '../../../shared/ui/icon/icon.component';
import { DataFetch } from '../../../models/data-source';
import { LeadFeature } from '../../../map/features/leads/lead-feature';
import { ProspectFeature } from '../../../map/features/prospects/prospect-feature';
import { CacheService } from '../../../services/cache.service';
import { PlacePullService, PullSummary } from '../../../services/place-pull.service';
import { PullJobItemComponent } from './pull-job-item.component';

@Component({
  selector: 'app-pull-activity', standalone: true,
  imports: [DataListComponent, DataListItemDirective, BrIconComponent, PullJobItemComponent],
  templateUrl: './pull-activity.component.html', styleUrls: ['./pull-activity.component.css'],
})
export class PullActivityComponent implements OnInit, OnDestroy {
  @ViewChild('jobsList') jobsList?: DataListComponent<PullSummary>;
  newJobId: string | null = null;
  readonly trackJob = (_index: number, job: PullSummary): string => job.jobId;
  private readonly destroyed$ = new Subject<void>();
  private readonly sessionReset$ = new Subject<void>();
  private readonly refreshedJobs = new Map<string, string>();
  readonly fetchJobs: DataFetch<PullSummary> = query => this.pull.list('all', query.page, query.pageSize).pipe(
    tap(page => this.refreshLeads(page.items)),
    takeUntil(this.sessionReset$), takeUntil(this.destroyed$),
  );

  constructor(private readonly pull: PlacePullService, private readonly feature: ProspectFeature,
    private readonly leads: LeadFeature, private readonly cache: CacheService) {}

  ngOnInit(): void {
    this.cache.sessionChanged$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.sessionReset$.next(); this.newJobId = null; this.refreshedJobs.clear();
    });
    timer(5000, 5000).pipe(takeUntil(this.sessionReset$), takeUntil(this.destroyed$)).subscribe(() => this.refreshVisible());
  }

  showJob(jobId: string): void {
    this.newJobId = jobId;
    this.refreshVisible();
    if (this.jobsList?.scrollBox) this.jobsList.scrollBox.nativeElement.scrollTop = 0;
  }

  refreshVisible(): void { this.jobsList?.refresh(); }

  private refreshLeads(jobs: PullSummary[]): void {
    let changed = false;
    for (const job of jobs) {
      if (!job.createsLeads || job.cellsDone === 0) continue;
      const version = `${job.cellsDone}:${job.status}`;
      if (this.refreshedJobs.get(job.jobId) === version) continue;
      this.refreshedJobs.set(job.jobId, version);
      changed = true;
    }
    if (changed) {
      this.feature.refreshCoverage();
      this.cache.clear('map-object-details');
      this.leads.clearCacheAndRefresh();
    }
  }

  ngOnDestroy(): void { this.destroyed$.next(); this.destroyed$.complete(); this.sessionReset$.complete(); }
}
